module.exports = __webpack_public_path__ + "static/media/oberflex-zebranochocolat-1200x2490.b5694ceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranochocolat-1200x2490.jpg
// module id = 1078
// module chunks = 37